
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#fff","d":"M0 0h20v20H0z"}}),_c('path',{attrs:{"d":"M17.888 2.168l-1.618.18a5.625 5.625 0 00-3.356 1.613l-7.356 7.355 3.18 3.182 7.357-7.355a5.62 5.62 0 001.613-3.357l.18-1.618z","stroke":"#253141","stroke-width":"1.125","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M5.558 11.317l-2.716-.906a.562.562 0 01-.22-.93l.174-.174a4.5 4.5 0 014.605-1.088l.941.314-2.784 2.784z","stroke":"#253141","stroke-width":"1.125","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M5.558 11.317l-2.716-.906a.562.562 0 01-.22-.93l.174-.174a4.5 4.5 0 014.605-1.088l.941.314-2.784 2.784zm3.181 3.18l.906 2.716a.562.562 0 00.93.22l.175-.174a4.5 4.5 0 001.087-4.605l-.312-.937-2.786 2.78z","stroke":"#253141","stroke-width":"1.125","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M8.739 14.497l.906 2.716a.562.562 0 00.93.22l.175-.174a4.5 4.5 0 001.087-4.605l-.312-.937-2.786 2.78zm-1.891.4a1.682 1.682 0 01-.495 1.193c-.658.659-3.975 1.591-3.975 1.591s.933-3.319 1.591-3.975c.29-.29.674-.464 1.083-.491","stroke":"#253141","stroke-width":"1.125","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    